export const MAINNET_ID = 1;
export const GOERLI_ID = 5;

export const CONTRACT_ADDRESSES = {
  [GOERLI_ID]: "0x20fb5fB71573f18b965437099E51E072c3AEB8cA",
  [MAINNET_ID]: "0x3D578dc45a7838CB9010757c73A5830b89d95C05"
};
